window.addEventListener('DOMContentLoaded', () => {
    const media = document.getElementById('media_feature_1300_');
    const video_btn = document.querySelector('.banner-video-btn');
    const textWard = document.querySelector('.banner-text-ward');

    video_btn.addEventListener(
      'click',
      () => {
        media.play();
        controlsEv(true);
      },
      false
    );
    function controlsEv(isShowControls) {
      isShowControls ? textWard.classList.remove('text-ward-show') : textWard.classList.add('text-ward-show');
      media.controls = isShowControls;
    }
  });